var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('O3D',[_c('O3D',{attrs:{"sx":5,"sy":5,"sz":5,"pz":-50}}),_c('O3D',{attrs:{"pz":-20,"py":10,"ry":_vm.pi * 0.25,"rz":0.3}},[_c('Spaceship')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }